import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

export interface Toast {
    header: string;
    body: string;
    type: string;
    delay?: number;
    classname?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    public toasts$: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>([]);

    get toasts(): Observable<Toast[]> {
        return this.toasts$.asObservable();
    }

    showStandard(header: string, body: string) {
        this.toasts$.next([...this.toasts$.value, {header, body, type: "standard", classname: "toast"}]);
    }

    showDanger(header: string, body: string) {
        this.toasts$.next([...this.toasts$.value, {header, body, type: "danger", classname: "bg-danger text-light toast", delay: 15000}]);
    }

    showSuccess(header: string, body: string) {
        this.toasts$.next([...this.toasts$.value, {header, body, type: "success", classname: "bg-success text-light toast", delay: 3000}]);
    }

    showInfo(header: string, body: string) {
        this.toasts$.next([...this.toasts$.value, {header, body, type: "info", classname: "bg-info text-light toast"}]);
    }

    remove(toast: Toast) {
        const currentToasts = this.toasts$.value;
        this.toasts$.next(currentToasts.filter(t => t !== toast));
    }
}
